<template>
  <div>
    <vs-popup :title="$t('SelectSerials')" :active.sync="showModal">
      <vs-table :data="serialsList" ref="table" class="custom-tbl stripe">
        <template slot="thead">
          <vs-th style="width: 3%">#</vs-th>
          <vs-th style="width: 80%">{{ $t("SerialNumbers") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td :data="data[indextr]">
              {{ parseInt(indextr) + 1 }}
            </vs-td>
            <vs-td>
              {{ data[indextr] }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}

.custom-tbl td {
  padding: 0.15rem 1rem !important;
}

.con-vs-checkbox {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
</style>

<script>
export default {
  name: "",
  props: {
    show: { default: false },
    serialsList: {
      default: {}
    }
  },
  data() {
    return {};
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  }
};
</script>
